// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* hide question number */
.qresponse .questionDetails .badge {
    display: none;
}

/* hide mandatory badge */
.qresponse .questionDetails .fa-certificate {
    display: none;
}

.qresponse .responseElements input.hasError {
    border-color:red;
}


/* set spacing between questions */
.qresponse {
    padding: 10px 0 5px 0;
}

/* setup text to look like control-label class */
.qresponse .questionText {
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 7px;
    opacity: 0.75;
    
}

/* remove margin so question and text left align on smaller view port */
.questionLabel {
    margin-left: -10px;
}

/* hide debug info */
.questionCollectionEditor .alert-danger {
    display: none;
}

/* hide footer */
.questionCollectionEditor .form-actions {
    display: none;
}

/* setup options to look like btn-default class */
.optionAsBtn {
    
    border: 1px solid #ccc!important;
    padding: 7px 13px;
    text-decoration: none !important;
    display: inline-block;
    color: #333;
    font-size: 14px;
}

.optionAsBtn:hover {
    background: #4b8df8;
    color: white;
}

.optionAsBtn.selectedOption {
    background: #4b8df8;
    color: white;
    border: 1px solid #4b8df8!important;
}



/*.qresponse {

    margin: 15px 10px;
    margin-bottom:20px; 
    padding: 12px;
    text-align: left;
    line-height:20px;
    width:initial;    

    color: #95A5A6 !important;
    background-color: white;
    
}

.qresponse .questionDetails {
    
} 
.qresponse:hover {
    
    background-color: rgba(214, 214, 221, 0.24);
    transition: background-color ease-in-out .25s,box-shadow ease-in-out .15s;
}


.qresponse .badge-info {
    width: 40px;
    height: 20px;
    padding: 10px;
    font-size: 15px !important;
    font-weight: bold;

    line-height: 0px;
}
   
.qresponse .questionText {
    font-size: 16px;
    font-familiy: verdana;
}

.qresponse label strong { display: none;}

.qresponse .responseElement, .qresponse .responseValue {
    color:#3a87ad;
    text-align: right;
    font-weight: bold;
}

.qresponse .responseElements strong {
    color: green;
    font-size: 18px;
}

.qresponse .responseElements .form-control {
    font-size: 18px;
    border-radius: 9px !important;
    
}



.qresponse .responseElements .form-control:focus {
    border-color: #aaaaaa;
}



.qresponse.flowChanges {
    border-color: rgb(244, 166, 45);
    background-color: olive;
}*/

/*.optionAsBtn {
	
    background-color: #D5D5D5;
    color: #737272;

   

	-moz-border-radius:9px;
	-webkit-border-radius:9px;
	border-radius:9px !important;
    
    border-width: 1px;
	display:inline-block;
	cursor:pointer;
	
	font-family:arial;
	font-size:16px;
	font-weight:normal;
	padding:10px 32px;
	text-decoration:none;
	text-shadow:0px 1px 0px #3d768a;

    text-decoration: none;
}
.optionAsBtn:hover {
	background:-webkit-gradient(linear, left top, left bottom, color-stop(0.05, #408c99), color-stop(1, #599bb3));
	background:-moz-linear-gradient(top, #408c99 5%, #599bb3 100%);
	background:-webkit-linear-gradient(top, #408c99 5%, #599bb3 100%);
	background:-o-linear-gradient(top, #408c99 5%, #599bb3 100%);
	background:-ms-linear-gradient(top, #408c99 5%, #599bb3 100%);
	background:linear-gradient(to bottom, #408c99 5%, #599bb3 100%);
	filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#408c99', endColorstr='#599bb3',GradientType=0);
	background-color:#408c99;
    text-decoration: none;
    color: white;


    transition: background-color ease-in-out .25s,box-shadow ease-in-out .15s;
}
.optionAsBtn:active {
	position:relative;
    text-decoration: none;
	top:1px;
}

.optionAsBtn:visited {
    text-decoration: none;
}

.optionAsBtn.selectedOption {
    background: #4b8df8;
    color: white;
    
}*/






`, "",{"version":3,"sources":["webpack://./src/assets/qce/qce2_ischeme.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,aAAa;AACjB;;AAEA,yBAAyB;AACzB;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA,kCAAkC;AAClC;IACI,qBAAqB;AACzB;;AAEA,gDAAgD;AAChD;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;;AAEjB;;AAEA,uEAAuE;AACvE;IACI,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB;IACI,aAAa;AACjB;;AAEA,gBAAgB;AAChB;IACI,aAAa;AACjB;;AAEA,iDAAiD;AACjD;;IAEI,gCAAgC;IAChC,iBAAiB;IACjB,gCAAgC;IAChC,qBAAqB;IACrB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,mCAAmC;AACvC;;;;AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAqEE;;AAEF;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAqDE","sourcesContent":["/* hide question number */\r\n.qresponse .questionDetails .badge {\r\n    display: none;\r\n}\r\n\r\n/* hide mandatory badge */\r\n.qresponse .questionDetails .fa-certificate {\r\n    display: none;\r\n}\r\n\r\n.qresponse .responseElements input.hasError {\r\n    border-color:red;\r\n}\r\n\r\n\r\n/* set spacing between questions */\r\n.qresponse {\r\n    padding: 10px 0 5px 0;\r\n}\r\n\r\n/* setup text to look like control-label class */\r\n.qresponse .questionText {\r\n    margin-top: 0;\r\n    margin-bottom: 0;\r\n    padding-top: 7px;\r\n    opacity: 0.75;\r\n    \r\n}\r\n\r\n/* remove margin so question and text left align on smaller view port */\r\n.questionLabel {\r\n    margin-left: -10px;\r\n}\r\n\r\n/* hide debug info */\r\n.questionCollectionEditor .alert-danger {\r\n    display: none;\r\n}\r\n\r\n/* hide footer */\r\n.questionCollectionEditor .form-actions {\r\n    display: none;\r\n}\r\n\r\n/* setup options to look like btn-default class */\r\n.optionAsBtn {\r\n    \r\n    border: 1px solid #ccc!important;\r\n    padding: 7px 13px;\r\n    text-decoration: none !important;\r\n    display: inline-block;\r\n    color: #333;\r\n    font-size: 14px;\r\n}\r\n\r\n.optionAsBtn:hover {\r\n    background: #4b8df8;\r\n    color: white;\r\n}\r\n\r\n.optionAsBtn.selectedOption {\r\n    background: #4b8df8;\r\n    color: white;\r\n    border: 1px solid #4b8df8!important;\r\n}\r\n\r\n\r\n\r\n/*.qresponse {\r\n\r\n    margin: 15px 10px;\r\n    margin-bottom:20px; \r\n    padding: 12px;\r\n    text-align: left;\r\n    line-height:20px;\r\n    width:initial;    \r\n\r\n    color: #95A5A6 !important;\r\n    background-color: white;\r\n    \r\n}\r\n\r\n.qresponse .questionDetails {\r\n    \r\n} \r\n.qresponse:hover {\r\n    \r\n    background-color: rgba(214, 214, 221, 0.24);\r\n    transition: background-color ease-in-out .25s,box-shadow ease-in-out .15s;\r\n}\r\n\r\n\r\n.qresponse .badge-info {\r\n    width: 40px;\r\n    height: 20px;\r\n    padding: 10px;\r\n    font-size: 15px !important;\r\n    font-weight: bold;\r\n\r\n    line-height: 0px;\r\n}\r\n   \r\n.qresponse .questionText {\r\n    font-size: 16px;\r\n    font-familiy: verdana;\r\n}\r\n\r\n.qresponse label strong { display: none;}\r\n\r\n.qresponse .responseElement, .qresponse .responseValue {\r\n    color:#3a87ad;\r\n    text-align: right;\r\n    font-weight: bold;\r\n}\r\n\r\n.qresponse .responseElements strong {\r\n    color: green;\r\n    font-size: 18px;\r\n}\r\n\r\n.qresponse .responseElements .form-control {\r\n    font-size: 18px;\r\n    border-radius: 9px !important;\r\n    \r\n}\r\n\r\n\r\n\r\n.qresponse .responseElements .form-control:focus {\r\n    border-color: #aaaaaa;\r\n}\r\n\r\n\r\n\r\n.qresponse.flowChanges {\r\n    border-color: rgb(244, 166, 45);\r\n    background-color: olive;\r\n}*/\r\n\r\n/*.optionAsBtn {\r\n\t\r\n    background-color: #D5D5D5;\r\n    color: #737272;\r\n\r\n   \r\n\r\n\t-moz-border-radius:9px;\r\n\t-webkit-border-radius:9px;\r\n\tborder-radius:9px !important;\r\n    \r\n    border-width: 1px;\r\n\tdisplay:inline-block;\r\n\tcursor:pointer;\r\n\t\r\n\tfont-family:arial;\r\n\tfont-size:16px;\r\n\tfont-weight:normal;\r\n\tpadding:10px 32px;\r\n\ttext-decoration:none;\r\n\ttext-shadow:0px 1px 0px #3d768a;\r\n\r\n    text-decoration: none;\r\n}\r\n.optionAsBtn:hover {\r\n\tbackground:-webkit-gradient(linear, left top, left bottom, color-stop(0.05, #408c99), color-stop(1, #599bb3));\r\n\tbackground:-moz-linear-gradient(top, #408c99 5%, #599bb3 100%);\r\n\tbackground:-webkit-linear-gradient(top, #408c99 5%, #599bb3 100%);\r\n\tbackground:-o-linear-gradient(top, #408c99 5%, #599bb3 100%);\r\n\tbackground:-ms-linear-gradient(top, #408c99 5%, #599bb3 100%);\r\n\tbackground:linear-gradient(to bottom, #408c99 5%, #599bb3 100%);\r\n\tfilter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#408c99', endColorstr='#599bb3',GradientType=0);\r\n\tbackground-color:#408c99;\r\n    text-decoration: none;\r\n    color: white;\r\n\r\n\r\n    transition: background-color ease-in-out .25s,box-shadow ease-in-out .15s;\r\n}\r\n.optionAsBtn:active {\r\n\tposition:relative;\r\n    text-decoration: none;\r\n\ttop:1px;\r\n}\r\n\r\n.optionAsBtn:visited {\r\n    text-decoration: none;\r\n}\r\n\r\n.optionAsBtn.selectedOption {\r\n    background: #4b8df8;\r\n    color: white;\r\n    \r\n}*/\r\n\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
